import { queryOptions } from '@tanstack/react-query';
import { getReviewAutomationSettings as getSettingsAPI } from 'src/common/Scraper';
import { ReviewAutomationSettingsResponse } from '../../types/review-automation.type';

/**
 * Returns React Query queryOptions to fetch review automation settings for an account and location.
 *
 * @param accountId - Google Business Profile account ID
 * @param locationId - Google Business Profile location ID
 */
export const getReviewAutomationSettingsQuery = (accountId: string, locationId: string, siteId?: string) => {
  return queryOptions({
    queryKey: ['getReviewAutomationSettings', accountId, locationId, siteId],
    queryFn: () => getSettingsAPI(accountId, locationId, siteId),
    enabled: !!accountId && !!locationId,
  });
};

export default getReviewAutomationSettingsQuery;
